@if (touched) {
<div>
  @for (error of listaErrores; track error; let i = $index) {
  <span class="myError">
    <div class="colorRed">{{ error }}{{ i < listaErrores.length - 1 ? ',' : '' }}</div>
  </span>
  }
</div>
}
